var treeUtil = {}

/**
递归找到满足条件的树形对象
 * @param {array<TreeNdoe>} treeNodeList 对象
 * @param {String} propertyName 属性名
 * @return {String} value 匹配值

  path=“obj.valu1”  =>return true
*/
treeUtil.getNodeCascadeBy = function (treeNodeList, propertyName, value) {
  if (!treeNodeList) return null
  for (let i = 0; i < treeNodeList.length; i++) {
    if (treeNodeList[i][propertyName] == value) return treeNodeList[i]
    var treeNode = treeUtil.getNodeCascadeBy(treeNodeList[i].children, propertyName, value)
    if (treeNode) return treeNode
  }
  return null
}
//iview新版本导致Disabled属性需要删除
treeUtil.clearDisabled = function (treeNodeList) {
  if (!treeNodeList) return
  for (let item of treeNodeList) {
    if (!item.disabled) {
      if (item.hasOwnProperty('disabled')) {
        delete item.disabled
      }
    }
    if (item.children && item.children.length > 0) {
      treeUtil.clearDisabled(item.children)
    }
  }
}

export default treeUtil
